<template>
  <div>
    <Breadcrumbs main="" :title="$t('lbl_EMPBE_ProductInfoCenter')" />
    <div
      class="b-sidebar-backdrop bg-dark"
      style="z-index: 100"
      v-if="sidebarMenu"
      @click="handleSidebarHide"
    ></div>
    <visitorPermission>
      <template v-slot:body>
        <div class="container-fluid">
          <div class="">
            <div class="row">
              <productListing
                ref="production"
                :hideSidebarNavMenu="hideSidebarNavMenu"
              ></productListing>
              <b-sidebar
                id="productRightpopup"
                class="customSidebar"
                title=""
                right
                bg-variant="white"
                :shadow="true"
                :no-close-on-backdrop="true"
                :no-header-close="true"
                ref="productRightpopup"
                v-model="sidebarMenu"
              >
                <router-view ref="currentItem"></router-view>
                <div class="d-flex" slot="header">
                  <button
                    type="button"
                    style="border: none; background-color: transparent"
                    @click="handleSidebarHide"
                  >
                    <i class="icon-close f-14"></i>
                  </button>
                </div>
              </b-sidebar>
            </div>
          </div>
        </div>
      </template>
    </visitorPermission>
  </div>
</template>

<script>
import { computed } from "vue";
import { mapGetters } from "vuex";
import { userService } from "@/_services";
import productListing from "./productlisting.vue";
import { AlertDialog } from "@/_helpers/AlertDialog";

export default {
  mixins: [AlertDialog],
  components: {
    productListing,
  },
  data() {
    return {
      sidebarVisible: false,
      permissionData: null,
      sidebarMenu: this.currentRouteName != "ProductInfoCenterDefault",
    };
  },
  created() {
    this.sidebarMenu = this.currentRouteName != "ProductInfoCenterDefault";
  },
  mounted() {
    this.sidebarMenu = this.currentRouteName != "ProductInfoCenterDefault";
  },
  computed: {
    ...mapGetters({
      getPermissionJsonByUser: "responsePermission/getPermissionJsonByUser",
    }),
    currentRouteName() {
      return this.$route.name;
    },
    user() {
      return this.$store.state.authentication.user;
    },
    companyid() {
      return this.user.empCompanyId;
    },
  },
  watch: {
    currentRouteName: {
      handler() {
        this.sidebarMenu = this.currentRouteName != "ProductInfoCenterDefault";
      },
    },
    sidebarMenu: {
      handler() {
        this.$nextTick(() => {
          this.sidebarMenu = this.currentRouteName != "ProductInfoCenterDefault";
        });
      },
    },
  },
  mounted() {
    // 监听子组件的刷新事件
    this.$on("refresh", this.refresh);
  },
  provide() {
    return { permissionData: computed(() => this.permissionData) };
  },
  // created(){
  //   this.GetSysCompanySponsorType();
  // },
  mounted() {
    this.GetSysCompanySponsorType();
  },
  methods: {
    SideBar() {
      return this.currentRouteName != "ProductInfoCenterDefault";
    },
    handleSidebarHide() {
      if (this.$refs.currentItem.dirty) {
        this.showLeavePage().then((result) => {
          if (result.isConfirmed) {
            this.$refs["productRightpopup"].hide();
            this.$router.replace("/productInfoCenter/default");
          }
        });
      } else {
        this.$refs["productRightpopup"].hide();
        this.$router.replace("/productInfoCenter/default");
      }
    },
    onBackdropClick() {},
    hideSidebarNavMenu() {
        this.$refs["productRightpopup"].hide();
        this.$router.replace("/productInfoCenter/default");
      // this.sidebarMenu = false;
    },
    //刷新
    refresh() {
      console.log("刷新父组件");
      this.GetSysCompanySponsorType();
      this.$refs.production.fetchData();
    },
    getotherInfo(){
      return this.$refs.production.otherInfo;
    },
    openSidebarAfterSave() {
      this.$root.$emit("bv::toggle::collapse", "productRightpopup");
    },
    GetSysCompanySponsorType() {
      var that = this;
      // console.log(this.companyid);
      if (this.companyid > 0) {
        userService
          .GetSysCompanySponsorType({ CompanyId: this.companyid })
          .then((res) => {
            if (res.isSuccessful) {
              var data = res.data;
              that.permissionData = this.getPermissionJsonByUser({ user: data });
            }
          });
      }
    },
  },
};
</script>
<style>
h5 {
  font-weight: bold;
}

.tabbed .nav {
  position: absolute;
  left: 22px;
  top: 33px;
  border-bottom: none;
}

.nav-pills .nav-link {
  font-size: 16px;
}
</style>
